<h1 class="pt-3">Bienvenue dans l'administration du Portail client</h1>

<div class="pt-4">
  <h2>
    Dernière information publiée
    <a class="ps-1" routerLink="informations" ngbTooltip="Gérer le fil d'information">
      <fa-icon icon="cog"></fa-icon>
    </a>
  </h2>
  @for (info of infos | infotype:'DIRECT'; track info.id) {
    @if ($first) {
      <div>
        <app-info-block [info]="info" [isFirst]="true" [adminMode]="false"></app-info-block>
      </div>
    }
  } @empty {
    <div>
      <p class="text-light-grey">Aucune information à afficher</p>
    </div>
  }
</div>

<div class="pt-4">
  <h2>
    Information(s) épinglée(s)
    <a class="ps-1" routerLink="informations" ngbTooltip="Gérer le fil d'information">
      <fa-icon icon="cog"></fa-icon>
    </a>
  </h2>
  @for (info of infos | infotype:'PINNED'; track info.id) {
    @if ($first) {
      <div>
        <app-info-block [info]="info" [isFirst]="true" [adminMode]="false"></app-info-block>
      </div>
    }
  } @empty {
    <div>
      <p class="text-light-grey">Aucune information épinglée à afficher</p>
    </div>
  }
</div>

@if (unhandledRequests && unhandledRequests.length > 0) {
  <div class="pt-4">
    <h2>
      <fa-icon icon="circle" class="text-danger"></fa-icon>
      Nombre de demandes non prises en charge : {{ unhandledRequests.length }}
    </h2>
    <div>
      <a class="ps-1" routerLink="demandes">
        Voir les demandes
      </a>
    </div>
  </div>
}
